import { Box, BoxProps, Typography } from '@mui/material';

import useStyles from './styles';

interface Props extends BoxProps {
  title: string;
  subtitle: string;
}

const LabelDescription = ({ title, subtitle, ...boxProps }: Props) => {
  const classes = useStyles();
  return (
    <Box component="label" {...boxProps}>
      <Typography className={classes.title}>{title}</Typography>
      <Typography className={classes.subtitle}>{subtitle}</Typography>
    </Box>
  );
};

export default LabelDescription;
